import { Bot } from "lucide-react";
import React from "react";

interface AuthLoadingScreenProps {
  message?: string;
}

const AuthLoadingScreen: React.FC<AuthLoadingScreenProps> = ({
  message = "Verificando autenticação...",
}) => {
  return (
    <div className="fixed inset-0 bg-linear-to-br from-purple-50 via-white to-purple-50 flex items-center justify-center z-50">
      <div className="text-center max-w-sm mx-auto px-4">
        {/* Logo/Ícone animado */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            {/* Efeito de brilho ao redor */}
            <div className="absolute inset-0 bg-purple-200 rounded-full blur-2xl opacity-40 animate-pulse"></div>
            {/* Card com o ícone */}
            <div className="relative bg-white p-6 rounded-2xl shadow-xl border border-purple-200">
              <Bot
                className="h-12 w-12 text-purple-600"
                style={{
                  animation: "float 3s ease-in-out infinite",
                }}
              />
            </div>
          </div>
        </div>

        {/* Spinner moderno */}
        <div className="mb-6 flex justify-center">
          <div className="relative">
            {/* Círculo de fundo */}
            <div className="w-16 h-16 border-4 border-purple-200 rounded-full"></div>
            {/* Círculo animado */}
            <div className="w-16 h-16 border-4 border-purple-600 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
          </div>
        </div>

        {/* Mensagem */}
        <div className="space-y-2 mb-6">
          <p className="text-lg font-semibold text-gray-800 tracking-tight">
            {message}
          </p>
          <p className="text-sm text-gray-500 font-medium">
            Por favor, aguarde...
          </p>
        </div>

        {/* Pontos de loading animados */}
        <div className="flex justify-center space-x-2">
          <div
            className="w-2.5 h-2.5 bg-purple-400 rounded-full animate-bounce"
            style={{ animationDelay: "0ms", animationDuration: "1.4s" }}
          ></div>
          <div
            className="w-2.5 h-2.5 bg-purple-500 rounded-full animate-bounce"
            style={{ animationDelay: "200ms", animationDuration: "1.4s" }}
          ></div>
          <div
            className="w-2.5 h-2.5 bg-purple-600 rounded-full animate-bounce"
            style={{ animationDelay: "400ms", animationDuration: "1.4s" }}
          ></div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
      `}</style>
    </div>
  );
};

export default AuthLoadingScreen;
